import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    TextField,
    Icon,
    ListItemSecondaryAction,
} from '@material-ui/core';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import { makeStyles } from '@material-ui/core/styles';
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Title from './../components/Complements/Title';
import DialogOTP from '../components/Complements/DialogOTP';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import { filterArrayEqual, isEmpty } from '../functions/arrays';
import { serverFindDataDefault } from "../services/crud";
import { feathersCreateData } from "../services"
import { sendLogs } from '../functions/function-logs';
//import { validateIp } from '../functions/store';
//import { osVersion, osName } from 'react-device-detect';
import { history } from '../helpers/history';
import StandardDialog from '../components/Complements/StandardDialog';
import { encrypt, decrypt } from '../functions/mobile';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    titleGreenBlackPrimary: {
        color: 'rgb(119, 169, 61)',
        fontWeight: 'bold',
        fontSize: '1.05rem'
    },
    titleGreenBlackSecondary: {
        color: 'rgb(119, 169, 61)',
        fontWeight: 'bold',
        fontSize: '1rem'
    },
    textTotalPayment: {
        [theme.breakpoints.up('xs')]: {
            fontSize: '110%'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '140%'
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '140%'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '140%'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '140%'
        },
    }
}));

const PayRollContainer = props => {

    const { user, handleOpenSnack, devices, company, states } = props

    const classestwo = useStyles();

    const [loading, setLoading] = useState(false)
    const [allData, setAllData] = useState([])
    const [accountSelected, setAccountSelected] = useState(company[0])
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    const [deudaTotal, setDeudaTotal] = useState("0")
    const [openDialogOTP, setOpenDialogOTP] = useState(false);
    const [actionProcess, setActionProcess] = useState({});
    const [initialTime, setInitialTime] = useState(Date.now());
    const [dateValue, setDateValue] = useState('')
    const [actionValidator, setActionValidator] = useState(1)
    const [companyAccount, setCompanyAccount] = useState({});
    const [payrollValidate, setPayrollValidate] = useState([]);
    const [payrollTray, setpayrollTray] = useState({});
    const [payrollTrayExist, setpayrollTrayExist] = useState(false);
    const [dialog, setDialog] = useState({ open: false, title: '', content: <div></div> });
    const [openSecondDialog, setOpenSecondDialog] = useState(false);
    const [externalObservation, setExternalObservation] = useState('');
    const [payrollerSelected, setPayrollerSelecter] = useState({});


    const mount = () => {
        const unmount = () => {
            company.length > 0 && findCompanyAccount(company[0].account_sequential)
            handleGetDataEmploye(0, 1, 1, company[0])
        }
        return unmount()
    }

    useEffect(mount, [])

    const findCompanyAccount = async (SecuencialCuenta) => {
        const finAcc = await feathersCreateData('core-server', { service: 'ACCOUNT', func: 'GET_ADITIONAL_INF_ACCOUNT', data: { SecuencialCuenta } })().then(res => !isEmpty(res) > 0 ? res.data : {}).catch(() => { })
        setCompanyAccount(finAcc)
        // console.log('=================*** finAcc ***===================');
        // console.log(finAcc);
        // console.log('====================================');
        return finAcc
    }

    const handleGetDataEmploye = async (rows, numberpage, flagAllData, company) => {

        try {
            setLoading(true)
            const dataEmploye = await serverFindDataDefault('payrolls',
                {
                    state: true,
                    owner: company.cedule,
                    $limit: 10,
                    $skip: rows,
                })()

                // console.log('=================*** dataEmploye ***===================');
                // console.log(dataEmploye);
                // console.log('====================================');

                // console.log('==================*** states ***==================');
                // console.log(states);
                // console.log('====================================');

            getDataViewTable(dataEmploye.total, numberpage)
            if ((flagAllData === 1) && (dataEmploye.total > 0)) {
                handleGetAllDataEmploye(dataEmploye.total, company.cedule, dataEmploye.data)
            }
            setLoading(false)
        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al cargar la información. Por favor vuelva a intentar mas tarde.", "error")
            setLoading(false)
        }

    }

    const handleGetAllDataEmploye = async (total, owner, data) => {

        try {
            let result = data
            const allDataEmploye = await serverFindDataDefault('payrolls', { owner, state: true, $limit: total })()
            getDeudaTotal(allDataEmploye.data)
            const payrollsTray = await serverFindDataDefault('payrolls-tray', { cedule: allDataEmploye.data[0].owner, state: 1 })().then(res => res.data.length > 0 ? res.data[0] : {}).catch(() => { })

            setpayrollTray(payrollsTray)
            if (!isEmpty(payrollsTray)) {
                const payrollsValidate = await serverFindDataDefault('payrolls-validate', { payroll: payrollsTray.id })().then(res => res.data.length > 0 ? res.data : []).catch(() => [])
                // console.log('payrollsValidate', payrollsValidate)
                if (payrollsTray.body !== ' ') {
                    const objectBodyTray = JSON.parse(payrollsTray.body)
                    objectBodyTray.forEach(err => {
                        result.forEach((dataEmploye, i) => {
                            if (dataEmploye.id === err.rolId) {
                                result[i].messageError = err.data.message
                            }
                        });
                    });
                }

                setAllData(result)
                setPayrollValidate(payrollsValidate)
                setpayrollTrayExist(true)

            } else {
                setAllData([])
            }
        } catch (error) {
            //console.log(error)
            getDeudaTotal([])
        }
    }

    const getDataViewTable = (total, numberpage) => {
        // console.log("*** CODES ***", codes)
        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;

        if (residuo > 0) {
            contador++;
        }

        setCount(contador)
        setPage(numberpage)
    }

    const getDeudaTotal = (data) => {

        let sumatoria = 0;

        for (let i = 0; i < data.length; i++) {
            sumatoria += parseFloat(data[i].value)
        }

        //console.log(sumatoria)

        setDeudaTotal(sumatoria.toFixed(2))
    }

    const onChangePagination = (e, numberpage) => {
        handleGetDataEmploye((numberpage - 1) * 10, numberpage, 1, company);
    }

    const handleChangeInputOtp = (valueinput) => {
        if (valueinput.target.value.toString().length === 4) {
            // console.log("VALUE OTP: ", valueinput)
            handleCompareCodeOtp({ data: valueinput.target.value.toString() });
        }

    }

    const handleCloseDialogOTP = () => {
        setOpenDialogOTP(false)
    };

    const handleAccountFind = (value) => {
        findCompanyAccount(value.account_sequential)
        handleGetDataEmploye(0, 1, 1, value)
        setAccountSelected(value)

    }

    const handleSelectCode = (value) => {
        setDateValue(value)
    }

    const handleCompareCodeOtp = async (valuesFormOtp) => {

        setLoading(true)
        try {

            const { ip, device, mac } = devices

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type: 26,
                inputOtp: valuesFormOtp.data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            const { error, message, type, viewDialogOtp } = responseValidateCode;

            if (error === false) {

                let object_send = {
                    service: 'PROCESS_PAYROLL',
                    observation: actionProcess === 'INTERNAL_OTP' ? dateValue : externalObservation,
                    otp: valuesFormOtp.data,
                    state: actionValidator,
                    ip,
                    mac,
                    device
                }

                const response = await feathersCreateData("payrolls-control", object_send)()

                if (response.error) {
                    handleOpenSnack(response.message, 'error');
                    setLoading(false)
                } else {
                    actionProcess === 'INTERNAL_OTP' && setDialog({ ...dialog, open: false })
                    handleOpenSnack(response.message, 'success');
                    history.push('/')
                }
            } else {

                handleOpenSnack(message, type);

                if (viewDialogOtp === false) {
                    setOpenDialogOTP(false)
                }

                setLoading(false)

            }

            /*             feathersCreateData('otp-validates', {
                            otp: valuesFormOtp.data,
                            type: 26,
                            user: user.vusk
                        })().then(async res => {
                            setOpenDialogOTP(false)
                            if (res.type === 'success') {
                                const { ip } = devices
                                let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                                let mac = 'NAVEGADOR'
                                if (!isEmpty(devices)) {
                                    // const { device, ip: ipDevice, mac: macDevice } = devices
                                    const { ip: ipDevice, mac: macDevice } = devices
                                    // deviceData = device;
                                    ipSend = ipDevice;
                                    mac = macDevice;
                                }
                                let object_send = {
                                    service: 'PROCESS_PAYROLL',
                                    cedule : actionProcess === 'INTERNAL_OTP' ? user.vusk : payrollerSelected.cedule,
                                    owner : accountSelected.cedule,
                                    accountSequential : accountSelected.account_sequential,
                                    company: accountSelected,
                                    payroll : payrollTray.id,
                                    month : (new Date ()).getMonth() + 1,
                                    year : (new Date ()).getFullYear(),
                                    // observation :actionProcess.action === 'INTERNAL_OTP' ? dateValue : `SOLICITADO POR ${user.vusk} ${user.customer.first_name} ${user.customer.surname}`,
                                    observation : actionProcess === 'INTERNAL_OTP' ? dateValue : externalObservation,
                                    otp : valuesFormOtp.data,
                                    value : deudaTotal,
                                    state: actionValidator,
                                    ip: ipSend,
                                    mac,
                                    device: `${osName} ${osVersion}`
                                }
            
                                const response = await feathersCreateData("payrolls-control", object_send)()
            
                                if (response.error) {
                                    handleOpenSnack(response.message, 'error');
                                } else {
                                    actionProcess === 'INTERNAL_OTP' && setDialog({...dialog, open: false})
                                    handleOpenSnack(response.message, 'success');
                                    history.push('/')
                                }
                            } else {
                                handleValidateAttemptsOtp(valuesFormOtp.data)
                                setLoading(false)
                                handleOpenSnack('Código no valido. Por favor vuelva a intentar.', 'error');
                            }
                            setLoading(false)
                        }).catch( err => {
                            setLoading(false)
                            handleOpenSnack(err.message, err.type)
                            handleValidateAttemptsOtp('ACADEMY_PROCESS')
                        }) */
        } catch (error) {
            //console.log(error)
            handleOpenSnack('no se ha podido realizar el pago.', 'error');
            setLoading(false)
        }
    }

    // const getNameMonth = (numberMonth) => {
    //     let meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
    //     return meses[numberMonth]
    // }

    const handlePayment = (type) => {

        try {

            if (allData.length > 0) {
                if (dateValue.trim() === '') {
                    handleOpenSnack("Ingrese una observacion, para aprobar la nomina.", "info")
                } else {
                    if (type === 'aprove') {
                        if (parseFloat(deudaTotal) > companyAccount.DisponibleTransaccion) {
                            handleOpenSnack('El saldo es insuficiente para realizar la transacción.', 'error')
                        } else if (parseFloat(deudaTotal) > parseFloat(accountSelected.max_amount)) {
                            handleOpenSnack('El valor excede el monto maximo permitido por la empresa', 'error')
                        } else {
                            handleGenerateOtp({ action: 'INTERNAL_OTP', data: {} })
                        }
                    } else {
                        handleGenerateOtp({ action: 'INTERNAL_OTP', data: {} })
                    }
                }
            } else {
                handleOpenSnack("Debe tener registrados empleados para poder realizar el pago.", "info")
            }
        } catch (error) {
            handleOpenSnack("Ha ocurrido un error al generar el codigo de verificación. Por favor vuelva a intentar.", "error")
        }
        //console.log(response)
    }

    const handleGenerateOtp = async (data) => {

        setLoading(true)
        setActionProcess(data.action)
        const { ip, device, mac } = devices

        const sendData = encrypt(JSON.stringify({ emited: 'NAVCREATECODE', type: 26, deviceData: device, ip, mac }))
        const responseGenerateCode = await feathersCreateData("codes-recovery", { sendData })()
        const { responseData } = responseGenerateCode
        const jsonDecrypt = JSON.parse(decrypt(responseData))

        const { type, alert } = jsonDecrypt;

        if (type === 'success') {
            setPayrollerSelecter(payrollerSelected)
            setOpenDialogOTP(true)
            setInitialTime(Date.now())
            setLoading(false)
        } else {
            setLoading(false)
            handleOpenSnack(alert, type)
        }

        /* if (data.action === 'INTERNAL_OTP') {
            feathersCreateData('codes-recovery',{emited: 'NAVCREATECODE', type: 26, deviceData: `${osName} ${osVersion}`, ip : ipSend, mac} )()
                .then((res) => {
                    setPayrollerSelecter(payrollerSelected)
                    setOpenDialogOTP(true)
                    setInitialTime(Date.now())
                    setLoading(false)
                }).catch(err => {
                    console.log(err)
                    setLoading(false)
                    handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente', 'error')
            })
        } else {
            feathersCreateData('codes-recovery',{emited: 'NAV_CREATE_EXTERNAL_CODE', type: 26, deviceData: `${osName} ${osVersion}`, ip : ipSend, external: payrollerSelected.cedule} )()
                .then((res) => {
                    setPayrollerSelecter(payrollerSelected)
                    setOpenDialogOTP(true)
                    setInitialTime(Date.now())
                    setLoading(false)
                }).catch(err => {
                    console.log(err)
                    setLoading(false)
                    handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente', 'error')
            })
        } */
    }

    const handleOpenListDialog = () => {
        try {
            setDialog({
                open: true, title: 'Estado de nomina',
                content: <List >
                    {
                        payrollValidate.map((payroller) => {
                            return <Grid container spacing={3}>
                                <Grid item xs={12} md={12} lg={12} sm={12}>
                                    <ListItem  >
                                        <ListItemAvatar>
                                            <Avatar>
                                                <Icon>account_circle</Icon>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary={`${JSON.parse(payroller.body).Nombres} ${JSON.parse(payroller.body).Apellidos}`} secondary={`Estado: ${filterArrayEqual(states, 'id', payroller.state)[0].name}`} />
                                        <ListItemSecondaryAction>
                                            {
                                                payroller.state === 1 && payroller.cedule !== user.vusk ?
                                                    // <Button variant="outlined" onClick={() => handleGenerateOtp({action: 'EXTERNAL_OTP', cedule: payroller.cedule  })} >Solicitar OTP</Button> :
                                                    <Button variant="outlined" disabled={openSecondDialog} style={{ backgroundColor: '#8EAB40' }} onClick={() => {
                                                        setLoading(true)
                                                        setPayrollerSelecter(payroller)
                                                        setOpenSecondDialog(true)
                                                        setLoading(false)
                                                        // handleGenerateOtp({action: 'EXTERNAL_OTP', cedule: payroller.cedule  })
                                                    }} >Solicitar Aprobación</Button> :
                                                    <Icon>{filterArrayEqual(states, 'id', payroller.state)[0].icon}</Icon>
                                            }
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </Grid>
                            </Grid>
                        })
                    }

                </List>

            })
        } catch (error) {
            //console.log(error)
        }
    }
    const handleDetailEmployee = (row) => {
        try {
            setDialog({
                open: true, title: 'Estado de nomina',
                content: <div>
                    <b>{`Identificación: `}</b>{`${row.identification} `}
                    <br />
                    <b>{`Nombre: `}</b>{`${row.name} `}
                    <br />
                    <b>{`Monto: `}</b>{`$ ${row.value} `}
                    <br />
                    <b style={{ color: 'red' }}>{`Error de transferencia: `}</b>{`${row.messageError}`}

                </div>
            })
        } catch (error) {

        }
    }
    const renderTable = () => {
        if (allData.length > 0 && payrollTrayExist) {
            return <div className={"container"}>
                <Grid item xs={12} md={12} lg={12}>
                    <Table className={"table"}>
                        <Thead>
                            <Tr>
                                <Th>Identificación</Th>
                                <Th>Tipo Identificación</Th>
                                <Th>Nombres</Th>
                                <Th># Cuenta</Th>
                                <Th className={"colunmvalue"}>Monto</Th>
                                <Th className={"colunmvalue"}>Estado</Th>
                                {/* <Th>Institución</Th> */}

                            </Tr>
                        </Thead>
                        <Tbody>
                            {

                                allData.map(row => (
                                    <Tr key={row.identification}>
                                        <Td>{row.identification}</Td>
                                        <Td>{row.identification_type}</Td>
                                        <Td>{row.name}</Td>
                                        <Td>{row.account}</Td>
                                        <Td>$ {row.value}</Td>
                                        <Td style={{ color: row.transfer !== undefined ? (filterArrayEqual(states, 'id', row.transfer).length > 0) ? filterArrayEqual(states, 'id', row.transfer)[0].color : '#FFFFFF' : '#FFFFFF', fontWeight: 'bold' }}>
                                            {
                                                (row.transfer === 4) ?
                                                    <Button variant="contained" color={"primary"}
                                                        onClick={() => { handleDetailEmployee(row) }}
                                                        fullWidth>{filterArrayEqual(states, 'id', row.transfer)[0].name}</Button> :
                                                    filterArrayEqual(states, 'id', row.transfer)[0].name
                                            }
                                        </Td>
                                        {/* <Td>{row.Institucion}</Td> */}
                                    </Tr>
                                ))

                            }

                        </Tbody>
                    </Table>
                    <br />
                    <Pagination
                        count={count}
                        color="primary"
                        page={page}
                        onChange={onChangePagination}
                    />
                </Grid>
            </div>
        } else {
            return <Alert severity="info">No se ha cargado ninguna información.</Alert>
        }

    }

    const renderBody = () => {
        return <div>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <Title>Nómina</Title>
                </Grid>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <FormControl variant="outlined" style={{ minWidth: '80%' }}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                        <Select
                            label="Seleccione una Cuenta"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue={company[0]}
                            onChange={(e) => handleAccountFind(e.target.value)}
                        >
                            {
                                company.map(option => {
                                    return <MenuItem key={option.id} value={option}>{`${option.name} - ${option.number_account}`}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    {
                        (allData.length > 0) ?
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={6} lg={6} >
                                    <List style={{ minWidth: '80%' }}>
                                        <ListItem button onClick={handleOpenListDialog}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <LocalAtmIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={
                                                    <span className={classestwo.titleGreenBlackPrimary}>
                                                        Estado
                                                    </span>
                                                }
                                                secondary={
                                                    <span>
                                                        {isEmpty(payrollTray) ? 'Cargando' : filterArrayEqual(states, 'id', payrollTray.state)[0].name}
                                                    </span>
                                                }
                                            />
                                        </ListItem>
                                    </List>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6} sm={12}>
                                    <List >
                                        <ListItem>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <LocalAtmIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={
                                                    <span className={classestwo.titleGreenBlackPrimary}>
                                                        Saldo Disponible
                                                    </span>
                                                }
                                                secondary={
                                                    <span >
                                                        {`$ ${companyAccount.DisponibleTransaccion === undefined ? '0.00' : (companyAccount.DisponibleTransaccion).toFixed(2)}`}
                                                    </span>
                                                }
                                            />
                                        </ListItem>
                                    </List>
                                </Grid>
                                <Grid item xs={12} md={12} lg={12} sm={12}>
                                    <TextField
                                        margin="normal"
                                        fullWidth
                                        name={'Concepto'}
                                        inputProps={
                                            { style: { 'textTransform': 'uppercase' } }
                                        }
                                        label={'Observacion'}
                                        onChange={(ev) => { handleSelectCode(ev.target.value.toUpperCase()) }}
                                    // ref={withFocus && (txt => { this.txt = txt;} ) }
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} lg={12} sm={12}>
                                    <Typography variant="h1" color="textSecondary" align="right" className={classestwo.textTotalPayment}>
                                        Total a pagar: $ {deudaTotal}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={12} sm={12}>
                                    {renderTable()}
                                </Grid>
                                {
                                    ((filterArrayEqual(payrollValidate, 'cedule', user.vusk).length > 0) && filterArrayEqual(payrollValidate, 'cedule', user.vusk)[0].state === 1) &&
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6} lg={6} sm={12}>
                                            <Button variant="contained" color='primary' onClick={() => {
                                                handlePayment('aprove')
                                                setActionValidator(2)
                                            }} fullWidth>Autorizar</Button>
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6} sm={12}>
                                            <Button variant="contained" onClick={() => {
                                                handlePayment('reject')
                                                setActionValidator(5)
                                            }} color='primary' fullWidth>Rechazar</Button>
                                        </Grid>
                                    </Grid>
                                }


                            </Grid> :
                            <Grid item xs={12} md={12} lg={12} sm={12}>
                                <Alert severity="info">No se ha cargado ninguna información.</Alert>
                            </Grid>
                    }
                </Grid>
            </Grid>
        </div>
    }

    return (
        <div>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                //info = { renderBody() }
                multiple={false}
            //panel = { 2 }
            />
            <LoadingScreen open={loading} />
            <DialogOTP
                openDialogOTP={openDialogOTP}
                loading={loading}
                initialTime={initialTime}
                showQR={false}
                onCloseDialogOTP={handleCloseDialogOTP}
                onKeyPress={handleChangeInputOtp}
                OTPSubmit={handleCompareCodeOtp}
            />
            <StandardDialog
                open={dialog.open}
                title={dialog.title}
                handleClose={() => setDialog({ ...dialog, open: false })} >
                {dialog.content}
                <LoadingScreen open={loading} />
            </StandardDialog>
            <StandardDialog handleClose={() => setOpenSecondDialog(false)} open={openSecondDialog} title={'Agregar Observacion'} fullScreen={false}>
                <Grid container spacing={3} justify="center">
                    <Grid item xs={12} sm={12} md={12} lg={12} >
                        <TextField id="standard-basic" label="Observacion" onChange={(e) => setExternalObservation(e.target.value)} fullWidth multiline rows={2} />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6} >
                        <Button variant="contained" color='primary' onClick={() => { handleGenerateOtp({ action: 'EXTERNAL_OTP' }) }} fullWidth disabled={externalObservation.trim() === ''}>Solicitar Aprobación</Button>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6} >
                        <Button variant="contained" color='primary' onClick={() => setOpenSecondDialog(false)} fullWidth >Cancelar</Button>
                    </Grid>
                </Grid>
                <LoadingScreen open={loading} />
            </StandardDialog>
        </div>
    )
}

export default connect(null, { sendLogs })(PayRollContainer);
